import React from 'react'
import { Redirect, useParams } from 'react-router-dom'
import { AuthDispatchContext, actions as authActions } from 'auth/Auth'

import styled from 'shared/theme'

import { AuthContext } from 'auth/Auth'
import LoginButton from 'auth/LoginButton'
import { homeLink, Login } from 'routing/routes'

import PageLayout from 'pages/util/PageLayout'
import MigrationNotice from 'shared/components/Header/MigrationNotice'
import Container from 'shared/components/Container'
import Text from 'shared/components/Text'
import MyIDLogo from './MyID.svg'
import Loader from 'shared/components/Loader'
import { useNonAuthSnowplowPageView } from 'shared/hooks/useSnowPlowPageView'

const LoginContent = styled(Container)`
    max-width: 42rem;
    margin: 0 auto;
    padding: 0 1.5rem;
    text-align: center;
`

const LoginContainer = styled(Container)`
    max-width: 22.5rem;
    text-align: center;
`

type NoSessionProps = { returnTo?: string }
const NoSession: React.FC<NoSessionProps> = ({ returnTo }): React.ReactElement => {
    return <LoginButton returnTo={returnTo} />
}

const NoSessionRedirect: React.FC<{ to: string | undefined }> = ({ to }) => {
    useNonAuthSnowplowPageView('Login', 'Login Page')
    return <NoSession returnTo={to} />
}

const SessionCheck: React.FC = (): React.ReactElement => {
    const auth = React.useContext(AuthContext)
    const { returnTo, forceRelogin } = useParams<Login>()
    const authDispatch = React.useContext(AuthDispatchContext)
    React.useEffect(() => {
        if (forceRelogin) {
            authDispatch(authActions.signout())
        }
    }, [forceRelogin, authDispatch])

    const renderOption = (): React.ReactElement => {
        if (auth.authenticationPending) {
            return (
                <Text size={'5'} my={3}>
                    Waiting for backend authentication...
                    <Loader size="small" center />
                </Text>
            )
        }

        if (!auth.signedIn || forceRelogin) {
            return <NoSessionRedirect to={returnTo} />
        }

        return <Redirect to={homeLink()} />
    }

    return (
        <PageLayout>
            <LoginContent flexDirection="column" alignItems="center" mt={96}>
                <MigrationNotice variant="standalone" />
                <LoginContainer
                    className="session no-session"
                    alignItems="stretch"
                    flexDirection="column"
                    mx={'auto'}
                >
                    <img
                        style={{ margin: '0 auto 32px' }}
                        alt="MyID Logo"
                        width="201"
                        height="77"
                        src={MyIDLogo}
                    />

                    {renderOption()}
                </LoginContainer>
            </LoginContent>
        </PageLayout>
    )
}

export default SessionCheck
